import { Panel, Th, Td } from "./ui";

// Immutable audit trail — ordinary users can never delete entries.
export default function SectionAudit({ rep }) {
  const rows = [...(rep.audit || [])].reverse();
  return (
    <Panel title={`Audit History (${rows.length}) — IMMUTABLE`} testid="panel-audit">
      <table className="w-full">
        <thead><tr><Th>DATE/TIME</Th><Th>USER</Th><Th>EMP ID</Th><Th>ACTION</Th><Th>FIELD/MODULE</Th><Th>PREVIOUS → NEW</Th></tr></thead>
        <tbody>
          {rows.map((a, i) => (
            <tr key={i} data-testid={`audit-row-${i}`}>
              <Td>{a.ts?.slice(0, 16)}</Td><Td>{a.user}</Td><Td>{a.employee_id}</Td>
              <Td>{a.action}</Td><Td>{a.module}</Td>
              <Td mono={false}>{a.old || a.new ? `${a.old || "—"} → ${a.new || "—"}` : "—"}</Td>
            </tr>
          ))}
        </tbody>
      </table>
    </Panel>
  );
}
